module.exports = __webpack_public_path__ + "static/media/telegram.a6153d37.svg";